module.exports = __webpack_public_path__ + "img/coin_right.68007cfd.png";